import { traineeKeys } from "~/modules/Trainee/TraineeProfile/scope";

export const challengesHabitsKeys = {
  habits: (traineeId: string) => [...traineeKeys.all(traineeId), "clientHabits"] as const,
  habitCompletions: (traineeId: string, since: string) =>
    [...traineeKeys.all(traineeId), "habitCompletions", since] as const,
  habitCompliance: (traineeId: string, clientHabitId: string, rangeStart: string) =>
    [...traineeKeys.all(traineeId), "habitCompliance", clientHabitId, rangeStart] as const,
  goals: (traineeId: string) => [...traineeKeys.all(traineeId), "goals"] as const,
  badges: (traineeId: string) => [...traineeKeys.all(traineeId), "badges"] as const,
  challengeParticipants: (traineeId: string) => [...traineeKeys.all(traineeId), "challengeParticipants"] as const,
  challengeSnapshots: (traineeId: string) => [...traineeKeys.all(traineeId), "challengeSnapshots"] as const,
};
